export const peripheralSettingsConfig = {
	temperature: {
		settings: ['name', 'offset', 'threshold', 'temperature_units'],
	},
	humidity: {
		settings: ['name', 'offset', 'threshold'],
	},
	voltmeter: {
		settings: ['name', 'threshold'],
		conditional: {
			range: 'measurement_range',
			xvoltage: 'voltmeter_custom_expression',
		},
	},
	analog: {
		settings: ['name', 'threshold', 'analog_settings'],
		conditional: {
			range: 'measurement_range',
			range_map: 'analog_calibration',
			xpercent: 'analog_custom_expression',
		},
	},
	digital: {
		settings: ['name', 'digital_input_settings', 'digital_input_type', 'digital_input_icon'],
	},
	switch: {
		settings: ['name', 'power_on_action'],
	},
};
